import { setSettingsData } from "../redux/settingsSlice";
import { GetApiMethod, PostApiMethod, PutApiMethod } from "./apiService";
import { store } from "../redux/store";
import { socketManager } from './socketConnection'
import { playPauseRinger, setAgentNotifications } from "../redux/notificationsSlice";
import { DtoIncomingNotification } from "../dto/dashboard.dto";
import React from "react";
import { useNavigate } from "react-router-dom";
import { showToaster } from "../redux/toastSlice";
import { Socket } from "socket.io-client";

let accessToken = localStorage.getItem("access_Token");
let socketUrl =
    process.env.REACT_APP_ADMIN !== localStorage.getItem("event")
        ? `/agent`
        : "/customer_admin";
let socketConnecting = false;
const loggerFlag = process.env.REACT_APP_LOGGER;
export let socketIssueAlertRef = false;
// connecting socket
let connectSocket = () => {
    if (accessToken) {
        socketConnecting = true;
        return socketManager.socket(
            socketUrl,
            {
                auth: {
                    token: accessToken,
                },
            })
    }
    return null;
};
let socketConnection = connectSocket();

// if connected making 'socketConnecting' false.
if (socketConnection) {
    socketConnection.on("connect", () => {
        socketConnecting = false;
    });
}

export const getSettingsDetails = (isAdmin = true) => {
    return GetApiMethod(isAdmin ? "admin/vendor/admin" : "tenant/agent/admin").then((response: any) => {
        if (response?.data?.data) {
            let settingsData: { [index: string]: any } = {};
            if (response.data.data) {
                settingsData = {
                    links: "",
                    name: response.data.data.name,
                    domain: response.data.data.domain,
                    logo: response.data.data.logo,
                    callerTune: response.data.data.callerTune,
                    id: response.data.data._id,
                    call_timeout: response.data.data.call_timeout,
                    // application_id: response.data.data.application_id,
                    // company_id: response.data.data.company_id,
                    // storageapi_key: response.data.data.storageapi_key,
                    // ssm_user_id: response.data.data.ssm_user_id,
                    // ssm_password: response.data.data.ssm_password,
                    // hummingBirdOrSSM: response.data.data.hummingBirdOrSSM,
                    notification_timeout: response.data.data.notification_timeout,
                    ringTone: response.data.data.ringTone,
                };
            }
            if (response.data.data.links) {
                settingsData["links"] = response.data.data.links;
            }
            store.dispatch(setSettingsData(settingsData));
        }
        return response.data;
    });
};

export const PhoneNumberFormatter = (number: string, numberLength: number) => {
    if (numberLength <= 3) {
        return number;
    } else if (numberLength < 7 && numberLength >= 4) {
        return `(${number.slice(0, 3)})-${number.slice(3)}`;
    } else if (numberLength >= 7) {
        return `(${number.slice(0, 3)})-${number.slice(3, 6)}-${number.slice(6, 11)}`;
    } else {
        return number;
    }
}

// convert number to standard format with code number
export const PhoneNumberFormatterWithCode = (number: string) => {
    return `+1 (${number.slice(1, 4)})-${number.slice(4, 7)}-${number.slice(7, 11)}`;
}

export const RevertFormattedPhoneNumber = (number: string) => {
    return String(number.replace(/[() -]/g, '')).replace(/\D/g, '');
}

export const RevertFormattedPhoneNumberWithCode = (number: string) => {
    return String(number.slice(2, 17).replace(/[() -]/g, '')).replace(/\D/g, '');
}

export const formatLocData = (data: any) => {
    let activeLocationsData = data.filter((item: any) => (item.isActive === true))
    const newArray = activeLocationsData.map(({ name, _id }: { name: string, _id: string }) => ({
        name: name,
        id: _id,
    }));
    return newArray;
};

export const checkDisbale = (locId: any, data: any) => {
    return data.some((item: any) => (item.targetValue?.split(",")[0] === locId))
}

export const GetWebSocketConnection = () => {
    if (localStorage.getItem("access_Token") && socketConnection) {
        if (socketConnection.connected === false && !socketConnecting) {
            socketUrl =
                process.env.REACT_APP_ADMIN !== localStorage.getItem("event")
                    ? `/agent`
                    : "/customer_admin";
            return socketManager.socket(socketUrl, {
                auth: {
                    token: localStorage.getItem("access_Token"),
                },
            });
        }
        return socketConnection;
    } else if (localStorage.getItem("access_Token") && !socketConnection && !socketConnecting) {
        socketUrl =
            process.env.REACT_APP_ADMIN !== localStorage.getItem("event")
                ? `/agent`
                : "/customer_admin";
        return socketManager.socket(socketUrl, {
            auth: {
                token: localStorage.getItem("access_Token"),
            },
        });
    } else {
        return null;
    }
};

export const disconnectWebSocketConnection = () => {
    let socket = GetWebSocketConnection()
    if (socket) {
        socket.disconnect();
        socket.close();
    }
    window.location.reload();
}

export const disconnectAudioCall = (notificationId: string | undefined, callSId: string | undefined = undefined) => {
    let socket = GetWebSocketConnection();
    if (socket) {
        socket.emit("end_call", {
            notificationId: notificationId,
            call_sid: checkCallSid(callSId),
        });
    }
}

export const addParticipantVideoCall = (room_name: string, agent_id: string, location_id: string | undefined, room_sid: string | undefined, isQrScanNotification: boolean | undefined, sessionName: string) => {
    let socket = GetWebSocketConnection();
    if (socket)
        socket.emit('add_participant', {
            roomName: room_name,
            agentId: agent_id,
            location_id: location_id,
            room_sid: room_sid,
            tenant_triggered: isQrScanNotification,
            sessionName: sessionName,
            userName: agent_id
        });
};

export const removeNotification = (notificationId: string | undefined, notificationData?: DtoIncomingNotification[]) => {
    if (notificationId) {
        let agentNotifications;
        if (notificationData) {
            agentNotifications = notificationData;
        } else {
            agentNotifications = [...store.getState().agentNotification.notificationData];
        }
        const updatedNotificationData = agentNotifications.filter(
            (item) => item.notificationId !== notificationId
        );
        store.dispatch(setAgentNotifications([...updatedNotificationData]));
    }
};

export const stopNotificationRing = (mode: string, notificationData?: DtoIncomingNotification[]) => {
    let agentNotifications;
    if (notificationData) {
        agentNotifications = notificationData;
    } else {
        agentNotifications = [...store.getState().agentNotification.notificationData];
    }
    if (mode === "reset") {
        if (agentNotifications.length <= 1) {
            store.dispatch(playPauseRinger(false));
        }
    } else {
        store.dispatch(playPauseRinger(false));
    }
};

export const removeBrbTimeStamp = () => {
    if (localStorage.getItem("brb_ts")) {
        localStorage.removeItem("brb_ts");
    }
}

export const removeBrbTimeout = () => {
    if (localStorage.getItem("brb_to")) {
        localStorage.removeItem("brb_to");
    }
}

export const checkVoiceInstancesInRemovedState = (callSID: string) => {
    let removedCallInstance = [...store.getState().agentNotification.removedCallInstance];
    let checkStatus: boolean = true;
    if (
        removedCallInstance &&
        removedCallInstance.includes(callSID)
    ) {
        checkStatus = false;
    }
    return checkStatus;
};

export const restrictIntialSpace = (e: any) => {
    if (e.keyCode === 32 && !e.target.value.length) {
        e.preventDefault();
    }
}

export const textValidator = (payload: Array<{ value: string, maxLength: number | null, minLength: number | null, key: string }>) => {

    let error: Array<{ "key": string, "type": string }> = [];
    payload.forEach(textField => {
        if (textField && textField.value && textField.maxLength && textField.value.trim().length > textField.maxLength)
            error.push({ "key": textField.key, "type": "maxLength" });
        if (textField && textField.value && textField.minLength && textField.value.trim().length < textField.minLength)
            error.push({ "key": textField.key, "type": "minLength" });
    });
    return { "validation": (error && error.length > 0) ? true : false, "error": error };
}

export const CheckPropertyExistOrNot = (data: any, key: string, loop?: string) => {
    if (loop) {
        return ((loop in data && data[loop] && key in data[loop]) ? data[loop][key] : "-")
    }
    return ((key in data && data[key]) ? data[key] : "-");
}

export const checkAbilityToUseZOOM = () => {
    const tenant_id = GetTenantId();
    const sitesUsingZoomMethod = process.env.REACT_APP_ZOOM_VIDEO_USING_SITE_TENANTIDS?.split(",");
    return sitesUsingZoomMethod?.includes(tenant_id);
}

export const GetTenantId = () => {
    let tenant_id = "";
    const env = process.env.REACT_APP_ENV
        ? process.env.REACT_APP_ENV
        : "dev";
    if (env === "local") {
        tenant_id = process.env.REACT_APP_tenant
            ? process.env.REACT_APP_tenant
            : "";
    } else {
        const domain_url = process.env.REACT_APP_DOMAIN_URL
            ? process.env.REACT_APP_DOMAIN_URL
            : ".dev.rcmanagers.com";
        const host = window.location.host;
        const domain_prefix = host.replace(domain_url, "");
        tenant_id = process.env[`REACT_APP_${domain_prefix}`] ?? "";
    }
    return tenant_id;
}

export const numberOnly = (event: any): boolean => {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
        return false;
    }
    if (charCode === 13) {
        event.preventDefault();
        return false;
    }
    return true;
}

export const Checkeligibility = (editpathname: string, locations: any, redirectTo: string) => {

    const navigate = useNavigate();
    React.useEffect(() => {
        if (editpathname === locations.pathname) {
            if (locations.state === null) {
                navigate(redirectTo);
            }
        }
    })
}

export const ActivateDeactivate =
    (
        PageName: string,
        name: string,
        route: string,
        id: string,
        status: boolean,
        routeTopage: any,
        linkUnlink?: boolean,
    ) => {

        PutApiMethod(linkUnlink ? `${route}/${id}` : `${route}/delete/${id}`, linkUnlink ? { activated: false } : { isActive: !status })
            .then((res) => {
                if (res.data.status === "Success") {
                    // if (route === "tenant/agent-crud") {
                    let socket = GetWebSocketConnection();
                    if (socket) {
                        socket.emit("get_team_status", async (res: any) => { });
                    }
                    // }
                    routeTopage();
                    linkUnlink ? DisplayToaster("bg-success", "Kiosk <b>" + name + "</b> has been unlinked successfully")
                        : DisplayToaster("bg-success", PageName + " " + "<b>" + name + "</b> has been " + (status ? "deactivated" : "activated") + " successfully");
                }
            })
            .catch((err) => {
                DisplayToaster("bg-danger", (DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!"));
            });
    }

export const DisplayToaster = (bg_color: string, message: string, timer?: string) => {
    store.dispatch(showToaster(
        {
            dialogBgColor: bg_color,
            dialogMsg: message,
            showDialog: true,
            timer: timer ? timer : '5000'
        }
    ));
}

export const RemoveExtraCharsFromNumber = (value: string) => {
    return (value.trim().charAt(0) === "+" ? value.trim().toString().slice(1) : value);
};

export const checkCallSid = (call_sid: string | undefined) => {
    if (call_sid?.startsWith("'") || call_sid?.startsWith('"') || call_sid?.startsWith("/") || call_sid?.startsWith(" ")) {
        return call_sid?.slice(1);
    } else {
        return call_sid;
    }
}

export const DisplayErrorMessages = (err: any) => {
    let err_msg = "";
    let cnt = 0;
    if (err.response.data.errors !== undefined) {
        err.response.data.errors.forEach((err: any, index: any) => {
            cnt += 1;
            err_msg += cnt + ". " + err.msg + "\n";
        });
    }
    if (err.response.data.error !== undefined) {
        err_msg = err.response.data.error ? err.response.data.error : "Something went wrong!";
    }
    return err_msg;
}

export const loggerHelper = (message: String, dataToBeLogged: any = undefined) => {
    if (loggerFlag && loggerFlag === 'true') {
        try {
            PostApiMethod('logger/write_logger', { message: message, details: dataToBeLogged });
        } catch (err: any) {
            console.log("error in logger helper ->", err);
        }
    }
};

export const getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor;
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }
    if (/android/i.test(userAgent)) {
        return "Android";
    }
    return "unknown";
}

export const infoUserForSocketIssue = (err: any, confMsgFlag: boolean = true, currentUserEmail: string | undefined = "Not Available") => {
    loggerHelper(`socket connect_error due to`, { "error": err, currentUserEmail: currentUserEmail ? currentUserEmail : "Not available" });
    if (!socketIssueAlertRef) {
        socketIssueAlertRef = true;
        if (confMsgFlag)
            window.confirm('Something went wrong, please refresh the page to stay connected.');
    }
}

export const getRecordingInfo = (callSid: string) => {
    return GetApiMethod('tenant/voicemail/get-recording/' + callSid).then((res) => {
        return res.data;
    });
}